import { quotation as quotationEn } from '../en/quotation';

export const quotation = {
  ...quotationEn,
  quotations: 'මිල ගණන්',
  allQuotations: 'සියලුම මිල ගණන්',
  createQuotation: 'මිල ගණනක් සාදන්න',
  quotationDetails: 'මිල ගණනේ විස්තර',
  status_draft: 'කෙටුම්පත',
  status_sent: 'යවන ලදී',
  status_accepted: 'පිළිගන්නා ලදී',
  status_rejected: 'ප්‍රතික්ෂේප කරන ලදී',
  status_expired: 'කල් ඉකුත් වී ඇත',
  status_converted: 'ඇණවුමක් බවට පරිවර්තනය කරන ලදී',
  convertToOrder: 'ඇණවුමක් බවට පරිවර්තනය කරන්න',
};
